export default __webpack_public_path__ + "img/settings-2.cad7dbc1.svg";